




import {Component, Prop, Vue} from 'vue-property-decorator';
import TiptapEditor from '@/components/editor/TiptapEditor.vue';

@Component({
             components: {TiptapEditor}
           })
export default class NoticeViewer extends Vue {
  @Prop({default: false}) private visible: boolean;
  @Prop({default: ''}) private content: string;

  get viewContent() {
    return this.content;
  }
}
